import { Component } from '@angular/core';

import {
  ContainerValidationComponent,
  EmptyComponent,
  ErrorComponent,
  LoaderComponent,
  Placeholder,
  PlaceholderComponent,
  SwiperLightComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        ContainerValidationComponent,
        EmptyComponent,
        ErrorComponent,
        LoaderComponent,
        PlaceholderComponent,
        SwiperLightComponent,
        TestIdDirective,
    ],
    template: `
    <cam-empty camTestId="cam-empty" />
    <cam-error camTestId="cam-error" />
    <cam-loader camTestId="cam-loader" />
    <cam-placeholder camTestId="cam-placeholder" [placeholder]="this.placeholder" />
    <cam-container-validation camTestId="cam-container-validation">validate</cam-container-validation>
    <cam-swiper-light camTestId="cam-swiper-light" [items]="this.items" [template]="itemTemplate" />
    <ng-template #itemTemplate let-item="item">
      <div>{{ item }}</div>
    </ng-template>
  `
})
export class UiContainersCase {
  public items = ['one', 'two', 'three'];
  public placeholder: Placeholder = { repeat: 2, type: 'text' };
}
